// Internal Dependencies:
import { templateReplace } from 'church-theme-library/utilities/templateReplace'

export function formattedDate( item ) {
	let formattedDate

	if ( item.is_event && item.start_time.raw ) {
		formattedDate = templateReplace( item.start_time.format_order, item.start_time.rendered )
	} else if ( item.date && item.date.raw ) {
		formattedDate = templateReplace( item.date.format_order, item.date.rendered )
	}

	return formattedDate
}

export function formattedDateData( item ) {
	let formattedDateData = {
		d: '',
		m: '',
		y: ''
	}

	if ( item.is_event && item.start_time.raw ) {
		formattedDateData = item.start_time.rendered
	} else if ( item.date && item.date.raw ) {
		formattedDateData = item.date.rendered
	}

	return formattedDateData
}

export function getNextDayOfWeek( dayOfWeek = 6 ) {
    let date = new Date()
    date.setDate( date.getDate() + ( 7 + dayOfWeek - date.getDay() ) % 7 )

    return date
}

export function getLastDayOfWeek( dayOfWeek = 6 ) {
    let date = new Date()
    date.setDate( date.getDate() - ( 7 - dayOfWeek + date.getDay() ) % 7 )

    return date
}

export function getNextDayOfWeekYmd( dayOfWeek = 6 ) {
	let nextDayOfWeek = getNextDayOfWeek( dayOfWeek )

	// Correct for timezone:
	const offset = nextDayOfWeek.getTimezoneOffset()
	nextDayOfWeek = new Date( nextDayOfWeek.getTime() - ( offset * 60 * 1000 ) )

	return nextDayOfWeek.toISOString().split( 'T' )[0]
}

export function getLastDayOfWeekYmd( dayOfWeek = 6 ) {
	let lastDayOfWeek = getLastDayOfWeek( dayOfWeek )

	// Correct for timezone:
	const offset = lastDayOfWeek.getTimezoneOffset()
	lastDayOfWeek = new Date( lastDayOfWeek.getTime() - ( offset * 60 * 1000 ) )

	return lastDayOfWeek.toISOString().split( 'T' )[0]
}

export function getQuarter( d ) {
	d = d || new Date()
	let m = Math.floor( d.getMonth() / 3 ) + 1

	return m > 4 ? m - 4 : m
}
